const doc = [({"da":({"js":({"admin":({"photo_colors":({"select":({"choose_photo_color":"Vælg fotofarve"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;